import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { SKIP_TENANT_AUTH_REFRESH } from '../interceptors/auth-refresh-context';
import { environment } from '../../../environments/environment';

export type TenantNotification = {
  id: string;
  type: string;
  title: string;
  message: string;
  actionUrl?: string | null;
  referenceType?: string | null;
  referenceId?: string | null;
  read: boolean;
  readAt?: string | null;
  createdAt: string;
};

export type TenantNotificationPage = {
  content: TenantNotification[];
  totalElements: number;
};

@Injectable({ providedIn: 'root' })
export class TenantNotificationService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiGatewayUrl}/property-service`;

  list(orgId: string, size = 10, page = 0): Observable<TenantNotificationPage> {
    return this.http.get<TenantNotificationPage>(
      `${this.base}/organization/${orgId}/notifications`,
      {
        params: { page: String(page), size: String(size) },
        context: this.nonBlockingContext(),
        withCredentials: true,
      },
    );
  }

  unreadCount(orgId: string): Observable<{ unreadCount: number }> {
    return this.http.get<{ unreadCount: number }>(
      `${this.base}/organization/${orgId}/notifications/unread-count`,
      { context: this.nonBlockingContext(), withCredentials: true },
    );
  }

  markRead(orgId: string, notificationId: string): Observable<TenantNotification> {
    return this.http.patch<TenantNotification>(
      `${this.base}/organization/${orgId}/notifications/${notificationId}/read`,
      {},
      { withCredentials: true },
    );
  }

  markAllRead(orgId: string): Observable<{ unreadCount: number }> {
    return this.http.post<{ unreadCount: number }>(
      `${this.base}/organization/${orgId}/notifications/read-all`,
      {},
      { withCredentials: true },
    );
  }

  streamUrl(orgId: string): string {
    return `${this.base}/organization/${orgId}/notifications/stream`;
  }

  private nonBlockingContext(): HttpContext {
    return new HttpContext().set(SKIP_TENANT_AUTH_REFRESH, true);
  }
}
